import { $request } from '@/utils/request';
import servers from '../servers';

/**
 * @description: 获取用户权限信息
 */
export function getInfo(): any {
  return $request({
    url: `${servers.api}/v1/user/info`,
    method: 'get',
  });
}

/**
 * @description: 退出登录接口
 */
export function logout(): any {
  return $request({
    url: `${servers.api}/v1/logout`,
    method: 'get',
  });
}
/**
 * @description: 获取OSS临时访问权限
 */
export function ossSts(): any {
  return $request({
    url: `${servers.api}/v1/common/oss/sts`,
    method: 'get',
  });
}
/**
 * @description: 获取航道
 */
export function getCourse(): any {
  return $request({
    url: `${servers.api}/v1/open/commonCode/getCourse`,
    method: 'get',
  });
}
/**
 * @description: 获取职能
 */
export function getFunction(): any {
  return $request({
    url: `${servers.api}/v1/open/commonCode/getFunction`,
    method: 'get',
  });
}
/**
 * @description: 检索oa
 */
export function searchOA(params: any): any {
  return $request({
    url: `${servers.api}/v1/user/search/${params}`,
    method: 'get',
  });
}

/**
 * @description: 检索角色
 */
export function searchRole(params: any): any {
  return $request({
    url: `${servers.api}/v1/role/search/${params}`,
    method: 'get',
  });
}

